import produce from 'immer'

import * as personalTokensCache from './personalTokensCache'

import {
  usePersonalTokenDeleteMutation,
  PersonalTokenDeleteMutation,
  PersonalTokenDeleteMutationVariables,
} from '@sketch/gql-types'

type UseDeletePersonalTokenProps = {
  onCompleted: (
    data: PersonalTokenDeleteMutation['personalTokenDelete']
  ) => void
}

export const useDeletePersonalToken = (props: UseDeletePersonalTokenProps) => {
  const { onCompleted } = props
  const [mutation] = usePersonalTokenDeleteMutation({
    onError: 'show-toast',
    onCompleted: data => onCompleted(data.personalTokenDelete),
  })

  return async (variables: PersonalTokenDeleteMutationVariables) => {
    return await mutation({
      variables,
      update: (cache, { data, errors }) => {
        if (!data || (errors && errors.length > 0)) return

        const me = personalTokensCache.get(cache)
        if (!me) return

        const identifierToDelete = data.personalTokenDelete.identifier

        const updatedMe = produce(me, user => {
          user.personalTokens = user.personalTokens.filter(
            token => token.identifier !== identifierToDelete
          )
        })

        personalTokensCache.set(cache, updatedMe)
      },
    })
  }
}
